import { Types } from "../constants/actionTypes";

export const LayoutActionCreators = {
  toggleAsideBar: () => ({ type: Types.TOGGLE_ASIDEBAR }),
};
